import React from "react";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { AppProvider } from "@toolpad/core/AppProvider";
import { DashboardLayout } from "@toolpad/core/DashboardLayout";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SearchIcon from "@mui/icons-material/Search";
import { useLocation } from "react-router-dom";
import LogoutButton from "../components/LogoutButton";
import AdminPage from "./AdminPage";
import BelgeSorgulama from "./BelgeSorgulama";
import CreateCollection from "./CreateCollection";  
import StorageIcon from "@mui/icons-material/Storage";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import ManageDocuments from "./ManageDocuments";


const NAVIGATION = [
  { kind: "header", title: "" },
  {
    segment: "",
    title: "Belge Yükleme",
    icon: <DashboardIcon sx={{ color: "primary.main" }} />,
  },
  {
    segment: "belge-sorgulama",
    title: "Belge Sorgulama",
    icon: <SearchIcon sx={{ color: "primary.main" }} />,
  },
  {
    segment: "koleksiyon-olustur",
    title: "Koleksiyon Oluştur",
    icon: <StorageIcon sx={{ color: "primary.main" }} />,
  },
  {
    segment: "belgeleri-yonet",
    title: "Belgeleri Yönet",
    icon: <FolderOpenIcon sx={{ color: "primary.main" }} />,
  }
];

const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#582b70" },
    secondary: { main: "#582b70" },
    background: { default: "#FFFFFF", paper: "#FFFFFF" },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          color: "#fff",
          backgroundColor: "#582b70",
          "&:hover": { backgroundColor: "#4a245f" },
        },
      },
    },
  },
});

const DashboardPage = () => {
  const location = useLocation();

  const renderPage = () => {
    if (location.pathname === "/belge-sorgulama") return <BelgeSorgulama />;
    if (location.pathname === "/koleksiyon-olustur") return <CreateCollection />;
    if (location.pathname === "/belgeleri-yonet") return <ManageDocuments />;
    return <AdminPage />;
  };

  return (
    <ThemeProvider theme={lightTheme}>
      <CssBaseline />
      <AppProvider
        navigation={NAVIGATION}
        branding={{
          logo: <img src="/tzv-logo.png" alt="tzv" />,
          title: "",
        }}
        theme={lightTheme}
      >
        <DashboardLayout>
          <Box
            sx={{
              py: 10,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              position: "relative",
            }}
          >
            <LogoutButton />
            {renderPage()}
          </Box>
        </DashboardLayout>
      </AppProvider>
    </ThemeProvider>
  );
};

export default DashboardPage;